import { Component, OnInit } from '@angular/core';
import { ActiveDirectoryService } from './service/active-directory.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

export interface activeDirectoryForm {
	toImport: {
		users: boolean | 0 | 1;
		equipments: boolean | 0 | 1;
		groups: boolean | 0 | 1;
	};
	interval: string;
	startAt: number;
	weekDay: string;
	formatedStartAt: string;
}

@Component({
	selector: 'register-form-active-directory',
	templateUrl: './active-directory.component.html',
	styleUrls: ['./active-directory.component.scss'],
})
export class ActiveDirectoryComponent implements OnInit {
	labels: LabelsInterface = {
		lbl_grupos: 'Groups',
		lbl_geral_equipamentos: 'Equipments',
		lbl_geral_usuarios: 'Users',
		lbl_geral_atualizar: 'Update',
		lbl_geral_salvar: 'Save',
		lbl_successful_updated: 'Successful updated',
		lbl_security_executar_agora: 'Run now',
		lbl_geral_horario_inicial: 'Start hour',
		lbl_geral_segunda: 'Monday',
		lbl_geral_terca: 'Tuesday',
		lbl_geral_quarta: 'Wednesday',
		lbl_geral_quinta: 'Thursday',
		lbl_geral_sexta: 'Friday',
		lbl_geral_sabado: 'Saturday',
		lbl_geral_domingo: 'Sunday',
		lbl_geral_dia_da_semana: 'Day of week',
		lbl_geral_intervalo_coleta: 'Data Collection Interval',
		lbl_geral_semanal: '',
		lbl_geral_diario: '',
		lbl_objetos_serao_importados: '',
		lbl_aguarde_processamento_demorar: '',
		lbl_finalizou_importacao: '',
		lbl_ckp_nenhum_indicador: '',
	};

	constructor(
		private LabelsService: LabelsService,
		private ActiveDirectoryService: ActiveDirectoryService,
		private NotificationService: NotificationService
	) {}

	selectedTab = 'import';

	isLoadingLabels = true;
	isLoadindAdData = true;
	isUpdatingAdFormData = false;
	assyncCount = [];

	adFormData: activeDirectoryForm = {
		toImport: {
			users: false,
			equipments: false,
			groups: false,
		},
		interval: 'daily',
		startAt: 0,
		weekDay: 'monday',
		formatedStartAt: '01:00 AM',
	};

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});
		this.ActiveDirectoryService.getAdData().subscribe((formData) => {
			this.adFormData = formData;
			this.isLoadindAdData = false;
		});
	}

	updateAdConfig(): void {
		if (this.isUpdatingAdFormData || this.assyncCount.length > 0) return;

		this.isUpdatingAdFormData = true;
		this.ActiveDirectoryService.putAdData(this.adFormData).subscribe(
			() => {
				this.isUpdatingAdFormData = false;
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
			},
			() => {
				this.isUpdatingAdFormData = false;
			}
		);
	}

	executeAdExtraction(): void {
		if (this.isUpdatingAdFormData || this.assyncCount.length > 0) return;

		const toImport = [];

		if (this.adFormData.toImport.equipments == 1) {
			toImport.push('adComputerImport');
			this.assyncCount.push('§');
		}
		if (this.adFormData.toImport.groups == 1) {
			toImport.push('adGroupImport');
			this.assyncCount.push('§');
		}
		if (this.adFormData.toImport.users == 1) {
			toImport.push('adUserImport');
			this.assyncCount.push('§');
		}
		if (toImport.length === 0) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_ckp_nenhum_indicador);
			return;
		}

		const labelFix = {
			adComputerImport: 'lbl_geral_equipamentos',
			adGroupImport: 'lbl_grupos',
			adUserImport: 'lbl_geral_usuarios',
		};

		this.NotificationService.setNotificationMessage(this.labels.lbl_aguarde_processamento_demorar);
		for (const index in toImport) {
			this.ActiveDirectoryService.executeAdExtraction(toImport[index])
				.subscribe(() => {})
				.add(() => {
					this.NotificationService.setNotificationMessage(
						`"${this.labels[labelFix[toImport[index]]].trim()}" ${this.labels.lbl_finalizou_importacao}`
					);
					this.assyncCount.pop();
				});
		}
	}

	handleStartAt(hour: number, ignoreSave?: boolean): string {
		const ampm: 'AM' | 'PM' = hour > 11 ? 'PM' : 'AM';
		const temporaryFormat = `${hour % 12 < 10 ? '0' + (hour % 12) : hour % 12}:00 ${ampm}`;
		if (!ignoreSave) this.adFormData.formatedStartAt = temporaryFormat;
		return temporaryFormat;
	}
}
